import { useEffect } from 'react';
import type { DependencyList } from 'react';
import { subscribe, unsubscribe } from './pub-sub';
import type { Listener, Payload, Topic } from './pub-sub';

export function useSubscribe<T>(
    event: Topic,
    listener: Listener<Payload<T>>,
    deps?: DependencyList,
): void {
    useEffect(() => {
        const id = subscribe(event, listener);
        return () => {
            unsubscribe(event, id);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps ?? []);
}
